"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _repeatInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/repeat");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.alertsMixin = alertsMixin;
exports.registerAlerts = exports.BmAlerts = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

var _i18n = require("@blue/services/i18n");

var _bmAlert = require("./bm-alert");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<bm-alert\n\t\t\t\ttype=\"", "\"\n\t\t\t\t@close=\"", "\"\n\t\t\t\t?closeable=\"", "\">", "</bm-alert>\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t", "\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\tdisplay: flex;\n\t\tcontain: content;\n\t\tflex-direction: column;\n\t}\n\t:host > bm-alert {\n\t\tmargin-bottom: 5px;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmAlerts = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmAlerts, _BlueElement);

  var _super = (0, _createSuper2.default)(BmAlerts);

  function BmAlerts() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmAlerts);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.alerts = [];
    return _this;
  }

  (0, _createClass2.default)(BmAlerts, [{
    key: "closeAlert",
    value: function closeAlert(alert, event) {
      var _context2;

      event.preventDefault();
      this.alerts = (0, _filter.default)(_context2 = this.alerts).call(_context2, function (a) {
        return a !== alert;
      });
      this.dispatchEvent(new CustomEvent('close', {
        detail: {
          closed: alert,
          alerts: this.alerts
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.html(_templateObject2(), (0, _element.guard)(this.alerts, function () {
        return _this2.renderAlerts(_this2.alerts);
      }));
    }
  }, {
    key: "renderAlerts",
    value: function renderAlerts(alerts) {
      var _this3 = this;

      return (0, _repeatInstanceProperty(_element))(alerts, function (i) {
        return i.msg;
      }, function (alert) {
        var _context3;

        return _this3.html(_templateObject3(), alert.type, (0, _bind.default)(_context3 = _this3.closeAlert).call(_context3, _this3, alert), alert.closeable, alert.msg);
      });
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-alerts';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        alerts: {
          type: Array,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);
  return BmAlerts;
}(_element.BlueElement);

exports.BmAlerts = BmAlerts;

var registerAlerts = function registerAlerts() {
  (0, _bmAlert.registerAlert)();
  (0, _element.register)(BmAlerts);
};

exports.registerAlerts = registerAlerts;

function alertsMixin(Base) {
  var _temp;

  registerAlerts();
  return _temp = /*#__PURE__*/function (_Base) {
    (0, _inherits2.default)(_temp, _Base);

    var _super2 = (0, _createSuper2.default)(_temp);

    (0, _createClass2.default)(_temp, null, [{
      key: "properties",
      get: function get() {
        return {
          alerts: {
            type: Array,
            reflect: false,
            attribute: false
          }
        };
      }
    }]);

    function _temp() {
      var _context4, _context5;

      var _this4;

      (0, _classCallCheck2.default)(this, _temp);

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      _this4 = _super2.call.apply(_super2, (0, _concat.default)(_context4 = [this]).call(_context4, args));
      _this4.alerts = [];
      _this4.alertCloseHandler = (0, _bind.default)(_context5 = _this4.alertCloseHandler).call(_context5, (0, _assertThisInitialized2.default)(_this4));
      return _this4;
    }

    (0, _createClass2.default)(_temp, [{
      key: "updated",
      value: function updated(changedProperties) {
        var _this$shadowRoot;

        (0, _get2.default)((0, _getPrototypeOf2.default)(_temp.prototype), "updated", this).call(this, changedProperties);
        var bmAlerts = ((_this$shadowRoot = this.shadowRoot) !== null && _this$shadowRoot !== void 0 ? _this$shadowRoot : this).querySelector('bm-alerts');
        bmAlerts.removeEventListener('close', this.alertCloseHandler);
        bmAlerts.addEventListener('close', this.alertCloseHandler);

        if (bmAlerts.alerts !== this.alerts) {
          bmAlerts.alerts = this.alerts;
        }
      }
    }, {
      key: "addAlert",
      value: function () {
        var _addAlert = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(msg, type) {
          var _context6;

          var closeable,
              _translate,
              _args = arguments;

          return _regenerator.default.wrap(function _callee$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  closeable = _args.length > 2 && _args[2] !== undefined ? _args[2] : true;
                  _translate = _args.length > 3 && _args[3] !== undefined ? _args[3] : true;

                  if (!_translate) {
                    _context7.next = 8;
                    break;
                  }

                  _context7.next = 5;
                  return (0, _i18n.translate)(msg);

                case 5:
                  _context7.t0 = _context7.sent;
                  _context7.next = 9;
                  break;

                case 8:
                  _context7.t0 = msg;

                case 9:
                  msg = _context7.t0;
                  this.alerts = (0, _concat.default)(_context6 = []).call(_context6, (0, _toConsumableArray2.default)(this.alerts), [{
                    msg: msg,
                    type: type,
                    closeable: closeable
                  }]);

                case 11:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee, this);
        }));

        function addAlert(_x, _x2) {
          return _addAlert.apply(this, arguments);
        }

        return addAlert;
      }()
    }, {
      key: "replaceAlerts",
      value: function () {
        var _replaceAlerts = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(msg, type) {
          var closeable,
              _args2 = arguments;
          return _regenerator.default.wrap(function _callee2$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  closeable = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : true;
                  this.cleanAlerts();
                  return _context8.abrupt("return", this.addAlert(msg, type, closeable));

                case 3:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee2, this);
        }));

        function replaceAlerts(_x3, _x4) {
          return _replaceAlerts.apply(this, arguments);
        }

        return replaceAlerts;
      }()
    }, {
      key: "cleanAlerts",
      value: function cleanAlerts() {
        this.alerts = [];
      }
    }, {
      key: "alertCloseHandler",
      value: function alertCloseHandler(event) {
        this.alerts = event.detail.alerts;
      }
    }, {
      key: "render",
      value: function render() {
        throw new Error('render method not implemented');
      }
    }]);
    return _temp;
  }(Base), _temp;
}
